import "bootstrap/dist/js/bootstrap.bundle";
import "bootstrap/dist/css/bootstrap.rtl.min.css";
import Container from "./components/admin_panel/Container";
import "./components/admin_panel/admin_panel.scss";
import "./assets/IRANSans4/Web/css/fontiran.css";
import { BrowserRouter, Routes, Route, useNavigate, Navigate } from "react-router-dom";
import Login from "./components/login/Login";
import AdminPanel from "./components/admin_panel/Container";
import QRCodeInformation from "./components/QRCodeInformation/QRCodeInformation";

import useAuth from "./authentication/useAuth";
import toast, { Toaster } from "react-hot-toast";
import { useState } from "react";
function App() {
  const { isLogged } = useAuth();
  // const navigate = useNavigate();
  const [update, setUpdate] = useState(false);
  function updater() {
    setUpdate(!update);
  }
  return (
    <div className="App">
      <Toaster></Toaster>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={isLogged() ? <Navigate to="/" replace></Navigate> : <Login updater={updater} />}></Route>
          <Route path="/" element={isLogged() ? <AdminPanel updater={updater}></AdminPanel> : <Navigate to="/login" replace></Navigate>}></Route>
          <Route path="/qr-code-information" element={<QRCodeInformation></QRCodeInformation>}></Route>
          <Route path="*" element={<div>404 not found</div>}></Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
